import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.258 24.28 5 16.044l1.585-1.58 6.673 6.654L27.415 7 29 8.58z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
export default SvgIcCheck;
